import React from "react";
import { Box, Typography } from "@mui/material";
import { animated } from "@react-spring/web";

const StatusOverlays = ({
  showEnvironmentLabel,
  envLabelBottom,
  playerOffset,
  overlayPadding,
  overlayWidth,
  currentEnvironment,
  instructionsVisible,
  topMessageOffset,
  currentInsight,
  showControlsOverlay,
  isPhone,
  currentGameState,
}) => {
  return (
    <>
      {showEnvironmentLabel && (
        <Box
          component={animated.div}
          sx={{
            position: "absolute",
            bottom: envLabelBottom,
            left: `calc(${playerOffset}px + 50% - ${playerOffset / 2}px)`,
            transform: "translateX(-50%)",
            color: "white",
            padding: overlayPadding,
            borderRadius: "8px",
            fontSize: "18px",
            maxWidth: overlayWidth,
            opacity: showEnvironmentLabel ? 1 : 0,
            transition: "opacity 500ms ease",
            zIndex: 20,
            pointerEvents: "none",
            textAlign: "center",
            textShadow: "0px 0px 10px rgba(0, 0, 0, 0.5)",
          }}
        >
          <Typography
            variant="caption"
            sx={{ fontSize: isPhone ? "1rem" : "1.2rem" }}
          >
            LOCATION
          </Typography>
          <Typography
            variant="h4"
            sx={{ fontSize: isPhone ? "1.6rem" : "2.2rem" }}
          >
            {currentEnvironment?.environmentName}
          </Typography>
        </Box>
      )}

      {instructionsVisible && (
        <Box
          component={animated.div}
          sx={{
            position: "absolute",
            top: topMessageOffset,
            left: `calc(${playerOffset}px + 50% - ${playerOffset / 2}px)`,
            transform: "translateX(-50%)",
            backgroundColor: "rgba(0, 0, 0, 0.7)",
            color: "#fff",
            padding: overlayPadding,
            maxWidth: overlayWidth,
            borderRadius: "10px",
            pointerEvents: "none",
            opacity: instructionsVisible ? 1 : 0,
            transition: "opacity 500ms ease",
            zIndex: 20,
            textAlign: "center",
            textShadow: "0px 0px 10px rgba(0, 0, 0, 0.5)",
          }}
        >
          <Typography variant="caption">INSTRUCTION</Typography>
          <Typography variant="h5" sx={{ fontSize: isPhone ? "1.1rem" : undefined }}>
            {currentInsight?.endConditions[0]?.name}
          </Typography>
        </Box>
      )}

      {showControlsOverlay && (
        <Box
          component={animated.div}
          sx={{
            position: "absolute",
            left: "50%",
            bottom: "40px",
            transform: "translateX(-50%)",
            background: "rgba(0, 0, 0, 0.68)",
            color: "#fff",
            padding: isPhone ? "10px 14px" : "12px 18px",
            borderRadius: "14px",
            display: "flex",
            flexDirection: "column",
            gap: "4px",
            pointerEvents: "none",
            zIndex: 24,
            boxShadow: "0 10px 32px rgba(0, 0, 0, 0.35)",
            border: "1px solid rgba(255, 255, 255, 0.08)",
            textAlign: "center",
            letterSpacing: "0.01em",
            maxWidth: overlayWidth,
          }}
        >
          <Typography variant="overline" sx={{ opacity: 0.8 }}>
            Controls
          </Typography>
          <Typography variant="subtitle1">Scroll to zoom in</Typography>
          <Typography variant="subtitle1">Drag to look around</Typography>
        </Box>
      )}

      <Box
        sx={{
          position: "absolute",
          top: `calc(var(--app-header-height, 0px) + 12px)`,
          right: "12px",
          backgroundColor: "rgba(0, 0, 0, 0.68)",
          color: "#fff",
          px: "10px",
          py: "6px",
          borderRadius: "8px",
          zIndex: 30,
          pointerEvents: "none",
          border: "1px solid rgba(255, 255, 255, 0.12)",
          boxShadow: "0 8px 18px rgba(0, 0, 0, 0.28)",
          textAlign: "right",
          maxWidth: isPhone ? "62vw" : "380px",
        }}
      >
        {/* <Typography
          variant="caption"
          sx={{ display: "block", opacity: 0.78, letterSpacing: "0.08em" }}
        >
          GAME STATE
        </Typography>
        <Typography
          variant="body2"
          sx={{
            fontFamily: '"area-extended", "area-normal", sans-serif',
            fontSize: isPhone ? "0.8rem" : "0.9rem",
            lineHeight: 1.2,
            wordBreak: "break-word",
          }}
        >
          {currentGameState}
        </Typography> */}
      </Box>
    </>
  );
};

export default StatusOverlays;
